module.exports = "/images/LogAndTag_2of7.jpg";